import api from './api';

class ManagementService {
  // Users
  async getUsers() {
    const response = await api.get('/management/users/');
    return response.data.results || response.data;
  }

  async createUser(userData) {
    const response = await api.post('/management/users/', userData);
    return response.data;
  }

  async updateUser(id, userData) {
    const response = await api.put(`/management/users/${id}/`, userData);
    return response.data;
  }

  async deleteUser(id) {
    await api.delete(`/management/users/${id}/`);
  }

  // Roles
  async getRoles() {
    const response = await api.get('/management/roles/');
    return response.data.results || response.data;
  }

  async createRole(roleData) {
    const response = await api.post('/management/roles/', roleData);
    return response.data;
  }

  async updateRole(id, roleData) {
    const response = await api.put(`/management/roles/${id}/`, roleData);
    return response.data;
  }

  async deleteRole(id) {
    await api.delete(`/management/roles/${id}/`);
  }

  // Docks
  async getDocks() {
    const response = await api.get('/management/docks/');
    return response.data.results || response.data;
  }

  async createDock(dockData) {
    const response = await api.post('/management/docks/', dockData);
    return response.data;
  }

  async updateDock(id, dockData) {
    const response = await api.put(`/management/docks/${id}/`, dockData);
    return response.data;
  }

  async deleteDock(id) {
    await api.delete(`/management/docks/${id}/`);
  }

  // Suppliers
  async getSuppliers() {
    const response = await api.get('/management/suppliers/');
    return response.data.results || response.data;
  }

  async createSupplier(supplierData) {
    const response = await api.post('/management/suppliers/', supplierData);
    return response.data;
  }

  async updateSupplier(id, supplierData) {
    const response = await api.put(`/management/suppliers/${id}/`, supplierData);
    return response.data;
  }

  async deleteSupplier(id) {
    await api.delete(`/management/suppliers/${id}/`);
  }

  // Material Types
  async getMaterialTypes() {
    const response = await api.get('/management/material-types/');
    return response.data.results || response.data;
  }

  async createMaterialType(materialData) {
    const response = await api.post('/management/material-types/', materialData);
    return response.data;
  }

  async updateMaterialType(id, materialData) {
    const response = await api.put(`/management/material-types/${id}/`, materialData);
    return response.data;
  }

  async deleteMaterialType(id) {
    await api.delete(`/management/material-types/${id}/`);
  }

  // Settings
  async getSettings() {
    const response = await api.get('/management/settings/get_settings_dict/');
    return response.data;
  }

  async updateSetting(id, settingData) {
    const response = await api.put(`/management/settings/${id}/`, settingData);
    return response.data;
  }
}

export default new ManagementService();
